export default __webpack_public_path__ + "static/media/goodbod_logo.82a52e85.jpg";